import { FC, useEffect, useState } from 'react'
import Icon from 'images/svg/digital_distribution/facebook.svg'
import { motion, useScroll, useTransform } from 'motion/react'

import { BIG_ORBIT_COEFF, ICON_SIZE } from '../../constants'

type TProps = { width?: number }

const Facebook: FC<TProps> = ({ width = 0 }) => {
  const [size, setSize] = useState<number>(width)

  useEffect(() => {
    setSize(width * BIG_ORBIT_COEFF)
  }, [width])

  const { scrollYProgress } = useScroll()

  const pDeg = useTransform(scrollYProgress, [0, 0.07, 0.13, 0.2], [-90, -105, -110, -115])
  const cDeg = useTransform(scrollYProgress, [0, 0.07, 0.13, 0.2], [90, 105, 110, 115])

  const translateX = size / 2 + ICON_SIZE / 2
  const translateY = -(ICON_SIZE / 2) + 4

  return (
    <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center overflow-hidden">
      <motion.div style={{ width: size, height: size, rotate: pDeg }}>
        <motion.div style={{ rotate: cDeg, translateX, translateY, width: ICON_SIZE }} transition={{ duration: 0.3 }}>
          <img
            src={Icon}
            className="w-full rounded-half object-contain"
            style={{ boxShadow: '0px 0px 38.9px 0px #1877F2' }}
          />
        </motion.div>
      </motion.div>
    </div>
  )
}

export { Facebook }
